export const GLOBAL_ADMIN_ROLE = 'GlobalAdminRole';

interface JwtPayload {
    realm_access?: {
        roles?: string[];
    };
}

/** Decode the payload of a JWT without verifying its signature. */
export function decodeJwt(token?: string | null): JwtPayload | null {
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length < 2) return null;
    try {
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(json) as JwtPayload;
    } catch {
        return null;
    }
}

/** True when the access token carries the GlobalAdminRole realm role. */
export function hasGlobalAdminRole(token?: string | null): boolean {
    const payload = decodeJwt(token);
    return payload?.realm_access?.roles?.includes(GLOBAL_ADMIN_ROLE) ?? false;
}
